/**
 * Reducer + action creators for the notification stack.
 *
 * Ported from the legacy Redux module (`redux/actionTypes.ts`,
 * `redux/actions.ts`, `redux/reducer.ts`) into a plain `useReducer` reducer.
 */

export const ADD_NOTIFICATION_TO_STACK = 'ADD_NOTIFICATION_TO_STACK';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const addNotificationToStack = (payload) => ({
    type: ADD_NOTIFICATION_TO_STACK,
    payload,
});

export const removeNotification = (payload) => ({
    type: REMOVE_NOTIFICATION,
    payload,
});

export const notificationsReducer = (state = [], action) => {
    switch (action.type) {
        case ADD_NOTIFICATION_TO_STACK: {
            const notification = action.payload;

            if (state.some(notif => notif.id === notification.id)) {
                return state; // Avoid duplicate messages
            }

            return [...state, notification];
        }

        case REMOVE_NOTIFICATION: {
            const notificationId = action.payload;

            return state.filter(notif => notif.id !== notificationId);
        }

        default:
            return state;
    }
};

export default notificationsReducer;